import React from 'react';
import 'dayjs/locale/es';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import { Card, Table } from '@avila-tek/ui/src';
import { createColumnHelper } from '@tanstack/react-table';
import { Event } from '../../../models';

dayjs.extend(localizedFormat);
dayjs.locale('es');

const columnHelper = createColumnHelper<Event>();

const columns = [
  columnHelper.accessor('createdAt', {
    header: 'Hora',
    cell: (info) => `${dayjs(info.row.original.createdAt).format('LLLL')}`,
  }),

  columnHelper.accessor('message', {
    header: 'Detalles',
    cell: (info) => (
      <div className="break-words box-border ">
        <h5 className="text-purple-300 font-semibold">
          {info.row.original.title}
        </h5>
        <div className=" break-words w-96">
          <p className="text-text-gray w-full whitespace-pre-wrap">
            {info.row.original.message}
          </p>
        </div>
      </div>
    ),
  }),
];

interface OrderHistoryProps {
  data: Event[];
}

function OrderHistory({ data }: OrderHistoryProps) {
  return (
    <Card className="overflow-x-auto p-5">
      <h4 className="text-xl mb-4 ml-2 text-text-black font-semibold">
        Historial de la orden
      </h4>
      <Table<Event> data={data} columns={columns} href="/app/orders">
        <Table.Content<Event> />
        <Table.Footer>
          <Table.Pagination className="ml-auto" />
        </Table.Footer>
      </Table>
    </Card>
  );
}

export default OrderHistory;
